import { render } from "./ConfigYearTable.vue?vue&type=template&id=7bd343d1"
import script from "./ConfigYearTable.vue?vue&type=script&lang=js"
export * from "./ConfigYearTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vncsalencar/Personal/Projects/araruna-anare-rollcall/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__